import { render } from "./AllTicketsDelayed.vue?vue&type=template&id=a8fe5ab2&scoped=true&ts=true"
import script from "./AllTicketsDelayed.vue?vue&type=script&lang=ts"
export * from "./AllTicketsDelayed.vue?vue&type=script&lang=ts"

import "./AllTicketsDelayed.vue?vue&type=style&index=0&id=a8fe5ab2&scoped=true&lang=less"

import exportComponent from "/home/gitlab-runner/builds/LUZizzTB/0/unicorn/frontend/unicorn-fe-support/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8fe5ab2"]])

export default __exports__